import React from "react";
import { FrameView } from "../../components/FrameView/FrameView";

export const HydrologicalMonitoring = () => {
  return (
    <FrameView
      src="https://sc.smartkulsary.kz/hydrological/"
      title="Hydrological Monitoring"
    />
  );
};
